import React from 'react';

const LegendaStackedAreaGraph = ({ tipo }) => {
  const legendaSesi = 'Rede de Ensino';

  const renderEstudante = () => {
    return (
      <div
        style={{
          width: '100%',
          display: 'flex',
          alignItems: 'start',
          justifyContent: 'center',
          marginTop: '2rem',
          flexDirection: 'column'
        }}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <div
            style={{
              margin: '1rem',
              width: '25px',
              height: '25px',
              background: '#ffff',
              border: '1px solid #c9c9c9',
              borderRadius: '8px'
            }}
          ></div>
          Estudante
        </div>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <div
            style={{
              margin: '1rem',
              minWidth: '25px',
              height: '25px',
              background: '#001AFF',
              borderColor: 'none',
              borderRadius: '8px'
            }}
          ></div>
          {legendaSesi}
        </div>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <div
            style={{
              margin: '1rem',
              minWidth: '25px',
              height: '25px',
              background: '#B972F1',
              borderColor: 'none',
              borderRadius: '8px'
            }}
          ></div>
          Departamento Regional
        </div>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <div
            style={{
              margin: '1rem',
              minWidth: '25px',
              height: '25px',
              background: '#47BEF3',
              borderColor: 'none',
              borderRadius: '8px'
            }}
          ></div>
          Escola
        </div>
      </div>
    );
  };
  const renderDr = () => {
    return (
      <div
        style={{
          width: '100%',
          display: 'flex',
          alignItems: 'start',
          justifyContent: 'center',
          marginTop: '2rem',
          flexDirection: 'column'
        }}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <div
            style={{
              margin: '1rem',
              width: '25px',
              height: '25px',
              background: '#001AFF',
              borderColor: 'none',
              borderRadius: '8px'
            }}
          ></div>
          {legendaSesi}
        </div>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <div
            style={{
              margin: '1rem',
              width: '25px',
              height: '25px',
              background: '#ffff',
              border: '1px solid #c9c9c9',
              borderRadius: '8px'
            }}
          ></div>
          Departamento Regional
        </div>
      </div>
    );
  };
  const rederDn = () => {
    return (
      <div
        style={{
          width: '100%',
          display: 'flex',
          alignItems: 'start',
          justifyContent: 'center',
          marginTop: '2rem',
          flexDirection: 'column'
        }}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <div
            style={{
              margin: '1rem',
              width: '25px',
              height: '25px',
              background: '#001AFF',
              borderColor: 'none',
              borderRadius: '8px'
            }}
          ></div>
          {legendaSesi}
        </div>
      </div>
    );
  };

  const rederSchool = () => {
    return (
      <div
        style={{
          width: '100%',
          display: 'flex',
          alignItems: 'start',
          justifyContent: 'center',
          marginTop: '2rem',
          flexDirection: 'column'
        }}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          {/* <div
            style={{
              margin: '1rem',
              width: '25px',
              height: '25px',
              background: '#001AFF',
              borderColor: 'none',
              borderRadius: '8px'
            }}
          ></div> */}
          {/* Avaliação Diagnóstica 2023 */}
        </div>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <div
            style={{
              margin: '1rem',
              width: '25px',
              height: '25px',
              background: '#ffff',
              border: '1px solid #c9c9c9',
              borderRadius: '8px'
            }}
          ></div>
          Avalia SESI 1° Semestre
        </div>
      </div>
    );
  };

  switch (tipo) {
    case 'estudante':
      return renderEstudante();
    case 'dr':
      return renderDr();
    case 'dn':
      return rederDn();
    case 'school-dn':
      return rederSchool();
    default:
      return <></>;
  }
};
export default LegendaStackedAreaGraph;
